import { handleActions } from 'redux-actions'

import { FetchStatus } from '@tabeeb/enums'
import * as rawActions from '../actions'

const initialState = {
  requireRefetch: false,
  deleteStatus: FetchStatus.Idle,
  items: [],
}

export default handleActions(
  {
    [rawActions.setPowerBIReportDependentModulesRefetch]: (state, action) => {
      return { ...state, requireRefetch: action.payload }
    },
    [rawActions.getPowerBIReportDependentModules.success]: (state, action) => {
      return { ...state, items: action.response.data }
    },
    [rawActions.deletePowerBIReportDependentModule.request]: (state, _action) => {
      return { ...state, deleteStatus: FetchStatus.Loading }
    },
    [rawActions.deletePowerBIReportDependentModule.failed]: (state, _action) => {
      return { ...state, deleteStatus: FetchStatus.Failed }
    },
    [rawActions.deletePowerBIReportDependentModule.success]: (state, action) => {
      const newItems = state.items.filter((item) => item.Id !== action.response.data)
      return { ...state, deleteStatus: FetchStatus.Loaded, items: newItems }
    },
  },
  initialState
)
